import type { Middleware, AnyAction } from '@reduxjs/toolkit';
import { FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';

// Actions from redux-persist can be noisy; skip them
const IGNORED = new Set([FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]);

export const reconLoggerMiddleware: Middleware = (store) => (next) => (action: AnyAction) => {
    // Skip noisy internal actions
    if (IGNORED.has(action.type)) return next(action);

    const prevState = store.getState();
    const result = next(action);          // reducers run here
    const nextState = store.getState();

    // Figure out which slices (reducers) changed by reference
    const changedSlices: string[] = [];
    for (const key of Object.keys(nextState)) {
        const prevSlice = prevState[key];
        const nextSlice = nextState[key];

        // only mark if the slice really changed
        if (!shallowEqual(prevSlice, nextSlice)) {
            changedSlices.push(key);
        }
    }

    // Pull nested payload actionType if present (your pattern)
    const nested = action?.payload?.actionType ?? '(none)';

    // Dev-friendly console output
    if (process.env.NODE_ENV !== 'production') {
        const label = `[Redux] action="${action.type}" payload.actionType="${nested}" | changedSlices=[${changedSlices.join(', ')}]`;
        if (changedSlices.length) {
            console.groupCollapsed(label);
            console.log('action:', action);
            console.log('changedSlices:', changedSlices);
            // If you want to peek the before/after of each changed slice:
            // changedSlices.forEach((k) => {
            //   console.log(`prev.${k}:`, prevState[k]);
            //   console.log(`next.${k}:`, nextState[k]);
            // });
            console.groupEnd();
        } else {
            console.log(label);
        }

    }

    return result;
};



function shallowEqual(objA: any, objB: any) {
    if (objA === objB) return true;
    if (typeof objA !== "object" || objA === null ||
        typeof objB !== "object" || objB === null) {
        return false;
    }

    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;

    for (const key of keysA) {
        if (objA[key] !== objB[key]) return false;
    }
    return true;
}
